import {debounce, on, tagName, template} from "../adapters/backbone-decorators";
import Handlebars from 'handlebars';
import GenericView from 'js/views/generic.view';
import ContentUsageCollection from 'js/models/content.usage.paginated.collection';
import PaginatedView from 'js/views/pagination.view';
import Template from 'js/templates/content.tile.hbs';
import PreviewTemplate from 'js/templates/content.preview.hbs';

require('l10n');

@template(Template)
@tagName('span')
class ContentTileView extends GenericView {

    constructor(options) {
        super();
        this.model = options.model;
        this.parentContentCollectionView = options.parentContentCollectionView;
        this.inPromoConfiguration = options.inPromoConfiguration;
        this.inVoucherConfiguration = options.inVoucherConfiguration;
        this.inServiceConfiguration = options.inServiceConfiguration;
        this.inContentManagement = !(this.inPromoConfiguration || this.inVoucherConfiguration || this.inServiceConfiguration);
        this.model.bind("change", this.render, this);
    }

    render() {
        super.render();
        this.$('[data-i18n]').i18n();
    }

    renderCollection() {
        var model = this.model;
        var parentContentCollectionView = this.parentContentCollectionView;
        this.collectionPreviewTemplate = Handlebars.compile(PreviewTemplate)({
            contentId: this.model.get("contentId"),
            fileType: this.model.get("fileType"),
            filePath: this.model.get("filePath"),
            filename: this.model.get("filename"),
            fileLength: this.model.get("fileLength"),
            fileSubType: this.model.get("fileSubType"),
            inPromoConfiguration: this.inPromoConfiguration,
            inVoucherConfiguration: this.inVoucherConfiguration,
            inServiceConfiguration: this.inServiceConfiguration,
            hasStatisticsToShow: this.ContentUsageCollection.hasStatisticsToShow,
            totalSent: this.ContentUsageCollection.totalSent,
            totalViewed: this.ContentUsageCollection.totalViewed,
            inContentManagement: this.inContentManagement,
            contentUsages: this.ContentUsageCollection.models,
            canDelete: this.ContentUsageCollection.canDelete,
            uploadedOn: this.model.get("created")
        });
        var content = $($.Metro.METRO_DIALOG.children(".content"));
        content.html(this.collectionPreviewTemplate);
        $($.Metro.METRO_DIALOG.children(".content")).find('#deleteContentFile-button').bind("click", function () {
            const contentId = model.get(model.idAttribute);
            console.log(contentId);
            parentContentCollectionView.deleteContent(contentId);
            $.Dialog.close();
        });

        $($.Metro.METRO_DIALOG.children(".content")).find('#insertContentOnService-button').on("click",
            $.proxy(this.insertContentOnService, this));

        const $window = $('.window.shadow');
        $window.css("height", "auto");
        $window.css("top", "15px");
        this.$('[data-i18n]').i18n();
        if (this.inContentManagement && this.ContentUsageCollection.hasStatisticsToShow) {
            if (this.paginationReport) {
                this.paginationReport.remove();
            }
            // Render collection the 1st time
            this.paginationReport = new PaginatedView({collection: this.ContentUsageCollection});
            this.paginationReport.render();
            // Replace view's pagination
            $('#pagination-report').html(this.paginationReport.$el);
        }
    }

    loadContentUsage() {
        this.ContentUsageCollection.url = `/CampaignCloud/Report/contentUsageStatistics/${this.model.get("contentId")}`;
        this.ContentUsageCollection.getFirstPage();
        console.info("Fetching content statistics");
    }

    @on('click')
    @debounce(500)
    handleClickedTile() {
        if (this.inContentManagement) {
            $.Dialog({
                overlay: true,
                shadow: true,
                icon: '<span class="icon  icon-file" style="color:white"></span>',
                title: this.model.get("filename"),
                draggable: true,
                height: 'auto',
                position: ['center', 'center'],
                content: '',
                padding: 0,
                onShow: () => {
                    this.ContentUsageCollection = new ContentUsageCollection();
                    this.ContentUsageCollection.on('sync', this.renderCollection, this);
                    this.loadContentUsage();
                }
            });
        } else {
            this.trigger("selected:content", {
                model: this.model,
                source: this.parentContentCollectionView.$el
            });
        }
    }
}

export default ContentTileView;